import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  InputHTMLAttributes,
} from 'react';

import { useField } from '@unform/core';


import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';

import { Container } from './styles';
import { Error } from '../styles';

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  setCallback?: Function;
  limit ?: number;
}
const TextareaInput: React.FC<Props> = ({
  name,
  icon: Icon,
  setCallback = () => {},
  limit = 0,
  ...rest
}) => {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const [isFocus, setIsFocus] = useState(false);
  const [isFilled, setIsFilled] = useState(!!defaultValue);

  const handleInputFocus = useCallback(() => {
    setIsFocus(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFilled(!!inputRef.current);

    const length = setIsFocus(false);
  }, [inputRef]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue(ref: any, value: string) {
        ref.setInputValue(value);
      },
      clearValue(ref: any) {
        ref.setInputValue('');
      },
    });
  }, [fieldName, registerField]);

  const [value,setValue] = useState<string>(defaultValue || '');

  const addValue = ( content ) => {
    setValue(content);
  }


  return (
    <Container isErrored={!!error} isFilled={isFilled} isFocused={isFocus}>
      <span>{rest.placeholder}</span>
      {Icon && <Icon />}

      <textarea cols={60} rows={20}
      onChange={(e) => addValue(e.target.value)}
      value={value}



        ref={inputRef}
        defaultValue={defaultValue}
        {...rest}
      />
      {limit > 0 && <p style={{ width: '300px', textAlign: 'right',color: value?.length > limit ? 'red' : '#333', marginTop:'10px'}}>{value?.length || 0} caractere(s) inseridos</p>}
      {limit > 0 && <p style={{ width: '100%', textAlign: 'right', fontSize: '12px'}}>Máximo de {limit} caracteres</p>}
     
      {error && (
        <Error title={error}>
          <FiAlertCircle />
        </Error>
      )}
    </Container>
  );
};
export default TextareaInput;
